module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_05_6DD79_1SE_G1W.d1e92545.png";